import type { PublicCorporateLocales } from "@/modules/corporate/types/locales"
import type { FunctionComponent } from "react"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { Link } from "@/modules/routing/components/Link"

import styles from "./FooterMenuList.module.css"

const URL_PATHNAME_PER_LOCALE: Record<PublicCorporateLocales, Record<string, string>> = {
  de: {
    about: "corporate/about-us",
  },
  en: {
    about: "corporate/about-us",
  },
  fr: {
    about: "corporate/a-propos",
  },
}
const URL_PER_LOCALE: Record<PublicCorporateLocales, Record<string, string>> = {
  de: {
    presskit: "https://press.jobteaser.com/de",
  },
  en: {
    presskit: "https://press.jobteaser.com/en",
  },
  fr: {
    presskit: "https://press.jobteaser.com/",
  },
}

export const FooterMenuListJobTeaser: FunctionComponent = () => {
  const { t } = useTranslation(["module_footer_fo"])
  const locale = useLocale() as PublicCorporateLocales

  return (
    <>
      <p className={styles.title}>JobTeaser</p>
      <ul className={styles.main}>
        {Object.entries(URL_PATHNAME_PER_LOCALE[locale] || URL_PATHNAME_PER_LOCALE.en).map(
          ([translationKey, pathname]) => (
            <li className={styles.item} key={translationKey}>
              <a className={styles.link} href={`/${URL_PATHNAME_PER_LOCALE[locale] ? locale : "en"}/${pathname}`}>
                {t(`module_footer_fo.${translationKey}`)}
              </a>
            </li>
          )
        )}

        {Object.entries(URL_PER_LOCALE[locale] || URL_PER_LOCALE.en).map(([translationKey, url]) => (
          <li className={styles.item} key={translationKey}>
            <a className={styles.link} href={URL_PER_LOCALE[locale] ? url : URL_PER_LOCALE.en[translationKey]}>
              {t(`module_footer_fo.${translationKey}`)}
            </a>
          </li>
        ))}

        <li className={styles.item} key={`/${locale}/companies/jobteaser/job-offers`}>
          <Link className={styles.link} href={`/${locale}/companies/jobteaser/job-offers`}>
            {t("module_footer_fo.join_us")}
          </Link>
        </li>
      </ul>
    </>
  )
}
